export enum AdType {
    HEADER,
    LEADER,
    MEDIUM_RECTANGLE,
    TAKEOVER,
    PRESBY,
}
